export default function portfolio(mutation) {
	const { type, payload } = mutation

	switch (type) {
		default:
			break
	}
}
